// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._IWDIipCwV8MxA {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 3px);
  text-align: center;
}
._IWDIipCwV8MxA .d1yuWYklRY1Ua4 {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-250, 18px);
  margin-bottom: var(--ds-space-0, 0);
}
._IWDIipCwV8MxA .qZGW6zU_a37fp5 {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
._IWDIipCwV8MxA .sRyAwwXF6aqMXr {
  margin-bottom: var(--ds-space-200, 16px);
}
._IWDIipCwV8MxA .sRyAwwXF6aqMXr .zi9XMOVegYIFvP {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
._IWDIipCwV8MxA .sRyAwwXF6aqMXr .QmiQLpIeREDVaw,
._IWDIipCwV8MxA .sRyAwwXF6aqMXr .j6TdXxwRAQfIeG {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
._IWDIipCwV8MxA .DPCcZmMss2RxNH {
  margin-bottom: var(--ds-space-200, 16px);
}
._IWDIipCwV8MxA .DPCcZmMss2RxNH .bAivxL1dNKLY0S {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
._IWDIipCwV8MxA .bVgUe2xzNkNP6i {
  display: grid;
  height: 70px;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 15px);
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
._IWDIipCwV8MxA .bVgUe2xzNkNP6i p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  ._IWDIipCwV8MxA {
    width: 265px;
  }
}
`, ""]);
// Exports
export var planCard = `_IWDIipCwV8MxA`;
export var name = `d1yuWYklRY1Ua4`;
export var info = `qZGW6zU_a37fp5`;
export var priceContainer = `sRyAwwXF6aqMXr`;
export var price = `zi9XMOVegYIFvP`;
export var frequency = `QmiQLpIeREDVaw`;
export var pricingVaries = `j6TdXxwRAQfIeG`;
export var ctaContainer = `DPCcZmMss2RxNH`;
export var currentPlan = `bAivxL1dNKLY0S`;
export var enterpriseFooter = `bVgUe2xzNkNP6i`;
export default ___CSS_LOADER_EXPORT___;
